import React from "react";
import styles from "./style.module.scss";
import logo from "../../../assets/images/mashie-shield-with-text-white.png";
import { Label } from "semantic-ui-react";
import { Link } from "react-router-dom";
import DeprecatedBanner from "./v2/utils/DeprecatedBanner";
import APIVersionDropdown from "./v2/utils/APIVersionDropdown";

const Endpoint = ({ type, location }) => {
    let colour = "green"; // for GET
    switch (type) {
        case "POST":
            colour = "blue";
            break;
        case "PUT":
            colour = "purple";
            break;
        case "PATCH":
            colour = "yellow";
            break;
        case "DELETE":
            colour = "red";
            break;
        default:
            colour = "green";
    }

    return (
        <h3>
            <Label size='large' color={colour}>
                {type}
            </Label>
            <span className={styles.endpoint}>{location}</span>
        </h3>
    );
};

export default function Index() {
    return (
        <div className='app events' style={{ paddingBottom: "100px" }}>
            <div className={styles.fullHeader} alt='event'>
                <img className={styles.entityLogo} src={logo} alt='logo' />
                <h1 className={styles.headerText}>
                    MASHIE Public API Documentation (v1)
                </h1>
                <h3 className={styles.whiteText}>
                    Manage your MASHIE experience
                </h3>
            </div>
            <div className='container'>
                <APIVersionDropdown version='v1' />

                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>About this API</h2>
                        <p>
                            This API allows you to fully manage your members'
                            access to the MASHIE app, including: creating
                            members, updating member information, renewing
                            memberships, deleting members, and releasing members
                            back to MASHIE.
                        </p>
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>Getting access</h2>
                        <p>
                            Please speak to your MASHIE rep to obtain access to
                            this API.
                        </p>
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>Authorisation</h2>
                        <p>
                            This API uses the Bearer Authentication scheme to
                            control access to resources. All requests must
                            provide a token within the authorisation header,
                            like so:
                            <pre className={styles.code}>
                                {"Authorization: Bearer <token>"}
                            </pre>
                            You can obtain your token by contacting your MASHIE
                            rep.
                        </p>
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>Data formats</h2>
                        <p>
                            This is a JSON API. For endpoints which allow
                            request bodies, please send your data as raw JSON
                            text. All responses will also be in the JSON format.
                            Be sure to set the following header on all requests:
                        </p>
                        <pre className={styles.code}>
                            {"Content-Type: application/json"}
                        </pre>
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>Endpoints</h2>
                        <p>
                            Please use the following base URL (BASE_API_URL) for
                            all API requests:
                        </p>
                        <pre className={styles.code}>
                            https://api.mashie.club/api/v1/public
                        </pre>
                        <p>
                            Please use the following base URL (BASE_IMAGE_URL)
                            for all image requests:
                        </p>
                        <pre className={styles.code}>
                            https://control.mashie.club/
                        </pre>
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-12'>
                        <h2>API Sections</h2>
                        <p className='mt-2'>
                            <Link to='/public/api-documentation/golf-club'>
                                <h3>Golf Club Documentation (v1)</h3>
                            </Link>
                        </p>
                        <p className='mt-2'>
                            <Link to='/public/api-documentation/golf-course'>
                                <h3>Golf Course Documentation (v1)</h3>
                            </Link>
                        </p>
                        <p className='mt-2'>
                            <Link to='/public/api-documentation/tee-time'>
                                <h3>Tee Time Documentation (v1)</h3>
                            </Link>
                        </p>
                        <p className='mt-2'>
                            <Link to='/public/api-documentation/user'>
                                <h3>User Documentation (v1)</h3>
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
            <DeprecatedBanner version='v1' />
        </div>
    );
}
